import axios from "@/axios";

export const namespaced = true

const defaultData = {
    id: 0,
    thirtyDay: false,
    sixtyDay: false,
    ninetyDay: false,
}

export const state = {
    subscription: Object.assign({}, defaultData),
}

export const getters = {
    subscription: (state) => state.subscription,
}

export const mutations = {
    SET_SUBSCRIPTION: (state, response) => (state.subscription = Object.assign({}, defaultData, response.data)),
    CLEAR_DATA: (state) => (state.subscription = defaultData),
}

export const actions = {
    async getSubscription({ commit }) {
        commit('SET_SUBSCRIPTION', await axios.get(`/api/subscriptions/user`))
    },
    async saveSubscription({ commit, state }) {
        try {
            return await axios.post('api/subscriptions/', state.subscription)
        }
        catch (error) {
            console.log("ERROR: ", error); //not handelleds
        }
    },
    clearData({ commit }) {
        commit("CLEAR_DATA");
    },
}
